const getters = {

  token: state => state.user.token,
  name: state => state.user.name,
  userType: state => state.user.userType, // 3 为租户  4为集团
  tenantId: state => state.user.tenantId,
  navigatorIndex: state => state.navigation.navigatorIndex,
  keyword: state => state.search.keyword,
  type: state => state.search.type,
  application:state=>state.user.application
  
  
}
export default getters
